export default __webpack_public_path__ + "static/media/arihant2.36234888.png";